import {
    Directive,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    OnInit,
    Output,
    Renderer2,
    TemplateRef,
} from '@angular/core';

@Directive({
    selector: '[hamTable]',
})
export class HamTableDirective implements OnInit {
    @HostBinding('class') className = 'ham-table';
    @Input() hamTable!: any[];
    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngOnInit() {}
}

@Directive({
    selector: '[hamHeaderCell]',
})
export class HamHeaderCellDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({
    selector: '[hamCell]',
})
export class HamCellDirective {
    @Output() cellClick = new EventEmitter<any>();
    constructor(public template: TemplateRef<any>) {}
}
@Directive({
    selector: '[hamMenuButton]',
})
export class HamMenuButtonDirective {
    constructor(public template: TemplateRef<any>) {}
}

@Directive({
    selector: '[hamTextCol]',
})
export class HamTextColDirective {
    @HostBinding('class') className = 'text-col';

    constructor() {}
}
@Directive({
    selector: '[hamDateCol]',
})
export class HamDateColDirective {
    @HostBinding('class') className = 'date-col';

    constructor() {}
}
@Directive({
    selector: '[hamNumberCol]',
})
export class HamNumberColDirective {
    @HostBinding('class') className = 'number-col';

    constructor() {}
}
@Directive({
    selector: '[hamHighlightCol]',
})
export class HamHighlighColDirective {
    @HostBinding('class') className = 'highlight1-col';

    constructor() {}
}
@Directive({
    selector: '[hamHighlightAlternativeCol]',
})
export class HamHighlighAltColDirective {
    @HostBinding('class') className = 'highlight2-col';

    constructor() {}
}
@Directive({
    selector: '[hamBadgeCol]',
})
export class HamBadgeColDirective {
    @HostBinding('class') className = 'badge-col';

    constructor() {}
}
